// Leaving a form page with unsaved changes asks first. The component has `dirty`.
export function confirmLeave(vm, next) {
  if (!vm.dirty || vm.saving || window.confirm(vm.$t("satellites.form.leave_confirm"))) {
    next();
  } else {
    next(false);
  }
}
